<template>
  <div class="category-doc">
    <div class="group__title flex items-center">
      <h2 class="title flex-1">
        {{ category.title }}
      </h2>
      <nuxt-link
        type="text"
        class="more-btn flex justify-center items-center cursor-pointer"
        aria-label="go academy detail"
        :to="{
          name: PageKey.ACADEMY_COLLECTION,
          params: { collection: `${category.outer_id}-${category.id}` },
        }"
      >
        {{ $t('cha-kan-geng-duo') }}
        <iconpark-icon name="arrowright" size="16"></iconpark-icon>
      </nuxt-link>
    </div>
    <div class="group__content">
      <BaseCard
        v-for="card in category.magic_school_detail?.slice(0, 4)"
        :key="card.id"
        :data="formatCard(card)"
        :link="{
          name: PageKey.BLOG,
          params: card.path_url
            ? {
                post: card.path_url,
              }
            : {
                // collection: `${category.outer_id}-${category.id}`,
                post: `${category.id}-${card.id}`,
              },
        }"
      >
        <template #title>
          <template v-if="cardName(card.name).length > 1">
            <span class="main-title font-[600]">
              {{ cardName(card.name)[0] }}
            </span>
            <span class="sub-title"> | {{ cardName(card.name)[1] }} </span>
          </template>
          <template v-else>
            {{ card.name }}
          </template>
        </template>
      </BaseCard>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { MagicSchoolDetail, IHelpCategory } from '~/api/module/help-center';
import BaseCard, { type IBaseCardData } from '~/components/content/baseCard.vue';
import { PageKey } from '~/constants/page';

const props = defineProps<{
  category: IHelpCategory;
}>();

const cardName = (name: string) => name.split('|');

const formatCard = (card: MagicSchoolDetail) => {
  return {
    title: card.name,
    cover_image_url: card.cover_url,
    ...card,
  } satisfies IBaseCardData;
};
</script>

<style lang="scss" scoped>
.group {
  &__title {
    h2 {
      font-size: 18px;
      line-height: 1.4;
      color: var(--text-1);
    }
    .more-btn {
      font-size: 14px;
      line-height: 1;
      color: var(--text-1);
      opacity: 0.6;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  &__content {
    display: grid;
    grid-template-columns: repeat(4, minmax(56px, 1fr));
  }
}
</style>
